var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('selectors',{attrs:{"prefix":"filter","modal":_vm.modal,"selectKey":_vm.titleKey,"title":_vm.title,"params":_vm.params},on:{"input":_vm.input},model:{value:(_vm.val),callback:function ($$v) {_vm.val=$$v},expression:"val"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }